export default {
      id: "cellphone-usage",
      viewBox: "0 0 44 56",
      url: "/dist/svg/" + "sprite.svg#cellphone-usage",
      toString: function () {
        return this.url;
      }
    }